import React from "react"

export const ProductWeights = ( { package_weights } ) => {
    const weightsList = package_weights && package_weights.map(( item_weight, i ) => {
        const { weight, package_type_icon, weight_uom } = item_weight
        const weightClassName = i === 0 ? 'product-types--options product-types--active' : 'product-types--options'

        return (
            <div className={weightClassName} key={i}>
                <img src={package_type_icon} alt="almo product weights"></img>
                <p>
                    {weight} {weight_uom}
                </p>
            </div>
        )
    })

    if (!weightsList || !weightsList.length) return null

    return (
        <div className="product-types">
            {weightsList}
        </div>
    )
}


export default ProductWeights